var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 1.54793H10V0.2146H14.6667V1.54793ZM15.8173 8.2146C15.5227 9.07927 14.4647 10.2146 12.4167 10.2146C10.3673 10.2146 8.70733 9.06193 8.70733 6.43127C8.70733 3.8246 10.2573 2.4846 12.3513 2.4846C14.406 2.4846 15.6607 3.6726 15.9347 5.43527C15.9867 5.7726 16.0073 6.22727 15.998 6.86193H10.6467C10.7333 9.0026 12.9687 9.06993 13.7053 8.2146H15.8173ZM10.6933 5.54793H14.0033C13.9333 4.5166 13.246 4.0686 12.352 4.0686C11.3747 4.0686 10.834 4.5806 10.6933 5.54793ZM4.31067 10.2066H0V0.2286H4.63533C8.286 0.2826 8.35533 3.85793 6.44867 4.8326C8.756 5.6726 8.83333 10.2066 4.31067 10.2066ZM2 4.2146H4.38933C6.06133 4.2146 6.32667 2.2146 4.18133 2.2146H2V4.2146ZM4.26067 6.2146H2V8.22527H4.22733C6.264 8.22527 6.13933 6.2146 4.26067 6.2146Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.e020c248c5e11d2a1ad2393fe151bd15.svg";
export { ForwardRef as ReactComponent };